import { useCallback } from 'react';
import { css } from '@linaria/core';
import { useFormikContext } from 'formik';
import { Button } from 'components/ui_library/Button';
import { IconLinkExternal } from 'components/Icons';
import { selectModelTypeFieldTypeInfo, BASIC_MODEL_FIELDS } from 'modules/Models/components/ModelForm/utils/utils';
import { formContainer, inputContainer } from 'modules/Models/components/ModelForm/styles';
import { FormikInitialValues } from 'modules/Models/components/ModelForm/utils/types';
import { SelectFormElement, SelectOptions } from './SelectFormElement';
const TRAINING_TEMPLATE_LINK = 'https://docs.clarifai.com/portal-guide/model/deep-training';
type TrainTemplateFormElementProps = React.InputHTMLAttributes<HTMLInputElement> & {
  path: string;
};
export function TrainTemplateFormElement({
  path
}: TrainTemplateFormElementProps): JSX.Element | null {
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const {
    fieldValueMap,
    trainingTemplateFields
  } = (values as FormikInitialValues);
  const {
    description,
    placeholder = ''
  } = selectModelTypeFieldTypeInfo(path, (values as FormikInitialValues));
  // TODO add train template to context from here
  const trainTemplate = fieldValueMap[path];
  const modelTypeEnumOptionFormatted: SelectOptions[] = trainingTemplateFields.sort((x, y) => 'recommended' in y ? 0 : x ? -1 : 1) // Sort recommended templates to be displayed first
  .map(modelType => {
    const content = <div className={trainingTemplateOption}>
          <div className="label">
            {modelType.id} {'recommended' in modelType && <div className="recommended-flag">Recommended</div>}
          </div>
          <Button variant="link">
            <a href={TRAINING_TEMPLATE_LINK} target="_blank" rel="noreferrer">
              <p>Learn more</p>
              <IconLinkExternal size={12} strokeWidth={5} color="#195AFF" />
            </a>
          </Button>
        </div>;
    const selectOption: SelectOptions = {
      id: modelType.id,
      content
    };
    return selectOption;
  });
  const handleSelectTrainTemplate = useCallback(e => {
    // Following condition added to prevent overriding of train_info.params (settings) in edit mode on initial load
    if (e.value === trainTemplate) {
      return;
    }
    const modelTypeEnumOption = trainingTemplateFields?.find(options => options.id === e.value)?.model_type_fields || [];
    Object.entries(fieldValueMap).forEach(([fieldPath, _]) => {
      if (fieldPath.includes('train_info.params') && !BASIC_MODEL_FIELDS.has(fieldPath)) {
        delete fieldValueMap[fieldPath];
      }
    });
    const trainInfoParams = modelTypeEnumOption.reduce((acc, field) => {
      acc[field.path] = field.default_value;
      return acc;
    }, ({} as {
      [key: string]: unknown;
    }));
    const newFieldValueMap = {
      ...fieldValueMap,
      [path]: e.value,
      ...trainInfoParams
    };
    setFieldValue('fieldValueMap', newFieldValueMap);
  }, [fieldValueMap, path, trainTemplate]);
  return <>
      <div className={formContainer}>
        <div className={inputContainer}>
          <SelectFormElement description={(description as string)} path={path} placeholder={placeholder} selectOptions={modelTypeEnumOptionFormatted} value={(trainTemplate as string)} onChange={handleSelectTrainTemplate} />
        </div>
      </div>
    </>;
}
const trainingTemplateOption = "odules__Models__components__ModelForm__components__FormComponentRenderer__FormComponents__TrainTemplateFormElement_tsx-trainingTemplateOption-t1408ic2";

require("./TrainTemplateFormElement.linaria.module.css!=!../../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./TrainTemplateFormElement.tsx");